import useSWRImmutable from 'swr/immutable';
import useCurrentUrl from '../useCurrentUrl';
import { GraphQLRequestProps, request } from '../../utils/graphql-request';
import { gql } from 'graphql-request';
import { swrTtlMiddleware } from '../../utils/swrTtlMiddleware';

interface AutocompleteResponse {
  listPopularSearchTerms: {
    hits: Array<{
      query: string;
    }>;
  };
}
const document = gql`
  query ListPopularSearchTerms($query: String, $pageSize: Int, $page: Int) {
    listPopularSearchTerms(query: $query, pageSize: $pageSize, page: $page) {
      hits {
        query
      }
    }
  }
`;

const fetcher = async (props: GraphQLRequestProps<{ query: string }>) => {
  const data = await request<AutocompleteResponse>(props);
  return data!.listPopularSearchTerms;
};

export const useAutocomplete = (searchTerm: string) => {
  const { locale } = useCurrentUrl();
  return useSWRImmutable(
    searchTerm
      ? {
          document,
          variables: { query: searchTerm },
          locale,
        }
      : null,
    fetcher,
    { keepPreviousData: true, use: [swrTtlMiddleware()] },
  );
};
